import { render, staticRenderFns } from "./QualificationType.vue?vue&type=template&id=060be960"
import script from "./QualificationType.vue?vue&type=script&lang=ts"
export * from "./QualificationType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports